import useStaffData from "@app/data-hooks/use-staff-data.ts";
import useAuth from "@app/hooks/use-auth.ts";
import { Button, Checkbox, FormControlLabel, Stack } from "@mui/material";
import { useForm } from "@tanstack/react-form";
import { QueryStatusRouter, Select } from "bi-lib";
import { useMemo } from "react";

export default function AccountNotificationForm() {
    const { userData } = useAuth();

    const staffId = useMemo(() => userData?.UserId, [userData]);

    const { staff, saveNotification } = useStaffData({ id: staffId });

    const form = useForm({
        defaultValues: {
            numberDaysReminderEmail: staff.data?.numberDaysReminderEmail,
            send15thReminderEmail: staff.data?.send15thReminderEmail,
            sendLastDayReminderEmail: staff.data?.sendLastDayReminderEmail,
        },
        onSubmit: ({ value }) => {
            saveNotification.mutate({
                staffingId: staffId,
                numberDaysReminderEmail: value.numberDaysReminderEmail,
                send15thReminderEmail: value.send15thReminderEmail,
                sendLastDayReminderEmail: value.sendLastDayReminderEmail,
            });
        },
    });

    return (
        <QueryStatusRouter queryHook={staff}>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    void form.handleSubmit();
                }}
            >
                <Stack spacing={1}>
                    <form.Field name={"numberDaysReminderEmail"}>
                        {(field) => (
                            <Select
                                label={"Reminder Email Frequency"}
                                value={field.state.value}
                                onChange={(e) => field.handleChange(e)}
                                options={[
                                    { label: "Never", value: 0 },
                                    { label: "Every 2 Days", value: 2 },
                                    { label: "Every 5 Days", value: 5 },
                                    { label: "Every 10 Days", value: 10 },
                                ]}
                            />
                        )}
                    </form.Field>
                    <form.Field name={"send15thReminderEmail"}>
                        {(field) => (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={field.state.value ?? false}
                                        onChange={(e) => field.handleChange(e.target.checked)}
                                    />
                                }
                                label={"Receive time entry reminder on the 15th"}
                            />
                        )}
                    </form.Field>
                    <form.Field name={"sendLastDayReminderEmail"}>
                        {(field) => (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={field.state.value ?? false}
                                        onChange={(e) => field.handleChange(e.target.checked)}
                                    />
                                }
                                label={"Receive time entry reminder on the last of the month"}
                            />
                        )}
                    </form.Field>
                    <Button variant={"contained"} type={"submit"} fullWidth>
                        Save
                    </Button>
                </Stack>
            </form>
        </QueryStatusRouter>
    );
}
